import { get, post } from '../utilities/api';

export const getBlock = (id, params = {}) => get({
  url: `/blocks/${id}`,
  params,
});

export const postBlock = (id, data = {}) => post({
  url: `/blocks/${id}`,
  data,
});
